import React, { useState } from 'react';
import DataGridToolbar from 'components/datagrid/DataGridToolbar';
import DeleteDiscountCodesDialog from './DeleteDiscountCodesDialog';
import { DiscountCodesTableRow } from './rows';

const DiscountCodesTableToolbar = () => {
	const [activeModal, setActiveModal] = useState<{
		id: 'delete';
		rowIds: string[];
	} | null>(null);

	const activeModalId = activeModal?.id;
	const activeModalRowIds = activeModal?.rowIds ?? [];

	const renderActiveDialog = () => {
		switch (activeModalId) {
			case 'delete':
				return (
					<DeleteDiscountCodesDialog
						discountCodeIds={activeModalRowIds}
						onClose={() => setActiveModal(null)}
					/>
				);
			default:
				return null;
		}
	};

	return (
		<>
			<DataGridToolbar
				persistKey="DiscountCodesTable"
				exportFileName="rentle-discounts"
				selectedRowsActions={{
					deleteAction: {
						enabled: true,
						handler: (rowIds) => setActiveModal({ id: 'delete', rowIds }),
					},
					exportAction: {
						enabled: true,
					},
					getRowLabel: (row: DiscountCodesTableRow) => row.code,
				}}
			/>
			{renderActiveDialog()}
		</>
	);
};

export default DiscountCodesTableToolbar;
